import { render, staticRenderFns } from "./OverviewView.vue?vue&type=template&id=1288bc28&"
import script from "./OverviewView.vue?vue&type=script&lang=js&"
export * from "./OverviewView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports